import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import AnswerButton from '../../components/Assessment/AnswerButton';
import Overlay from '../Widget/Overlay';
import OverlayPartner from '../Widget/OverlayPartner';
import OverlayPublisher from '../Widget/OverlayPublisher';
import WidgetHeader from '../Widget/WidgetHeader';

import { AutoScalingButtonSet } from '../../components/Buttons/AutoScalingButtonSet';
import { Container, RockTheVoteLabel } from '../DefaultStyles/Details';
import {
    Body,
    Content,
    Description,
    Details,
    DetailsContainer,
    Footer,
    RTVLogo,
    Title
} from '../DefaultStyles/Shared';
import { isLongText } from '../../components/Shared/commonFunctions';
import { RockTheVoteDetails } from '../../components/Shared/rockTheVoteDetails';
import ShareDrawer from '../../components/ShareDrawer';

import { onGoToForm } from './actions';
import {
    onBackWithinCard,
    setOverlayPartnerVisible,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import { CardTypes } from '../../utils/enums';

class ElectionReminderDetails extends React.Component {
    componentDidMount() {
        this.forceUpdate();
    }
    render() {
        return (
            <Container>
                <Overlay />
                <OverlayPublisher />
                <OverlayPartner
                    transitionType="right-to-left"
                    logo={RTVLogo}
                    name={this.props.rockTheVoteTitle}
                    description={this.props.rockTheVoteDescription}
                />
                <Body>
                    <WidgetHeader />
                    <Content isContactAction={false} isSingleAction={true}>
                        <Title
                            isLongText={isLongText(this.props.title, 60)}
                            isExtraLongText={isLongText(this.props.title, 95)}
                            onClick={e => {
                                this.props.setOverlayPartnerVisible(true, e, false);
                            }}
                            dangerouslySetInnerHTML={{
                                __html: this.props.title
                            }}
                        />
                        <DetailsContainer>
                            <Details>
                                <Description
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(
                                            true,
                                            e,
                                            false
                                        )
                                    }
                                    isLongText={isLongText(this.props.subTitle, 90)}
                                    isExtraLongText={isLongText(this.props.subTitle, 160)}
                                    dangerouslySetInnerHTML={{
                                        __html: this.props.subTitle
                                    }}
                                />
                                <RockTheVoteLabel
                                    color={this.props.theme.colors.primary}
                                    onClick={e =>
                                        this.props.setOverlayPartnerVisible(true, e, true)
                                    }
                                >
                                    {this.props.rockTheVoteLabel}
                                </RockTheVoteLabel>
                            </Details>
                        </DetailsContainer>
                    </Content>
                    <AutoScalingButtonSet mobileStyled={true} mobileLeftPosition={8}>
                        <AnswerButton
                            text={this.props.registerButtonText}
                            useLoadingSpinner={false}
                            onClick={() => {
                                this.props.setExitingCardProps(
                                    'electionReminder',
                                    this.props,
                                    this.props.activeAction
                                );
                                this.props.onGoToForm(
                                    this.props.actionIdentifier,
                                    this.props.actionInitiated
                                );
                            }}
                        />
                    </AutoScalingButtonSet>
                    <Footer>
                        <ShareDrawer
                            beforeBack={() => {
                                this.props.setExitingCardProps(
                                    'electionReminder',
                                    this.props,
                                    this.props.activeAction
                                );
                            }}
                            goBack={() => {
                                return this.props.card.type === CardTypes.actionChoice
                                    ? this.props.onBackWithinCard(
                                          this.props.actionIdentifier,
                                          this.props.card,
                                          true
                                      )
                                    : null;
                            }}
                            fullwidth={this.props.card.type === CardTypes.actionChoice}
                            rightAlign={this.props.card.type !== CardTypes.actionChoice}
                            hasBackButton={
                                this.props.card.type === CardTypes.actionChoice
                            }
                            backgroundColor={'#fff'}
                        />
                    </Footer>
                </Body>
            </Container>
        );
    }
}

ElectionReminderDetails.propTypes = {
    activeAction: PropTypes.object.isRequired,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    actionIdentifier: PropTypes.string.isRequired,
    card: PropTypes.object.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    rockTheVoteTitle: PropTypes.string,
    rockTheVoteDescription: PropTypes.string,
    registerButtonText: PropTypes.string.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    onGoToForm: PropTypes.func.isRequired,
    onBackWithinCard: PropTypes.func.isRequired,
    rockTheVoteLabel: PropTypes.string.isRequired,
    theme: PropTypes.object
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'electionReminder',
            ['/electionReminder', '/electionReminder/start'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        const defaultTitle = 'Sign up to receive local election updates.';
        const defaultSubtitle =
            'By staying informed of key dates and events, you can be sure you’re ready for the next election.';

        return {
            actionIdentifier: state.widget.activeAction.identifier,
            actionInitiated: state.electionReminder.actionInitiated,
            activeAction: state.widget.activeAction,
            card: state.widget.cards[state.widget.activeAction.order - 1],
            registerButtonText: state.widget.activeAction.customButtonText || 'SIGN UP',
            rockTheVoteDescription: RockTheVoteDetails.description,
            rockTheVoteLabel: RockTheVoteDetails.label,
            rockTheVoteTitle: RockTheVoteDetails.title,
            subTitle: state.widget.activeAction.text || defaultSubtitle,
            title: state.widget.activeAction.title || defaultTitle,
            theme: state.widget.theme
        };
    },
    {
        onBackWithinCard,
        onGoToForm,
        setExitingCardProps,
        setOverlayPartnerVisible
    }
)(ElectionReminderDetails);
